/**
 * Sentry configuration
 * This file contains configuration for Sentry error tracking
 */

/**
 * List of errors to ignore in Sentry reporting
 * Add patterns for errors that should not be reported to Sentry
 */
const SENTRY_IGNORE_ERRORS = [
  // Internal library errors
  "_abt/*init*/(arg[0]='isArray')",
  // Client script errors (not from our app)
  "TypeError: Cannot read properties of null (reading 'contentWindow')",
  // Is logged to AWS ALB
  "Opened not found page with status 404.",
  // Overall app errors that are not critical
  "write after end",
  // Happens on runners
  "Error - unable to load fileServer storage data. Maybe you have incorrect url?",
  "Error - unable to load fileServer storage data.",
  // GTM script zaletsi (not from our app)
  "No error message",
  "Can't find variable: _AutofillCallbackHandler",
  // GTM script zaletsi (not from our app)
  "Non-Error exception captured with keys: currentTarget, isTrusted, target, type",
  "Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target",
  "Cannot read properties of undefined (reading 'touches')",
  "TypeError: undefined is not an object (evaluating 'activeTab.id')",
  "is not a valid selector",
  // Footer errors
  "AbortError: Share canceled",
  "ResizeObserver loop completed with undelivered notifications.",
  // tztraveltrack.golibe.com footer script error
  "Cannot read properties of undefined (reading '$el')",
  "t.$_Tawk.i18next",
  "Cannot read properties of undefined (reading 'clientHeight')",
  // manntravelau.golibe.com site error - catched by our iFrame
  "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
  "(evaluating 'iFrame.contentWindow')",
  "iFrame is null",
];

module.exports = SENTRY_IGNORE_ERRORS;
